"use strict";

import BaseModel from "dias/core/models/baseModel";

class GutachtenPruefer extends BaseModel {
  constructor() {
    super("gutachten_pruefer");
  }
}

export default GutachtenPruefer;
